import React, {} from 'react';
const styles = {"link":"ScrollLink-module__link__1L2ON","arrow":"ScrollLink-module__arrow__iGmAG","chevron":"ScrollLink-module__chevron__b2j3E"};
/** An underlined link to a place further down the same page, with a round orange arrow before it. */
export function ScrollLink({ label, targetId }) {
    return (React.createElement("a", { className: styles.link, href: `#${targetId}` },
        React.createElement("svg", { className: styles.arrow, viewBox: "0 0 20 20", "aria-hidden": "true" },
            React.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }),
            React.createElement("path", { className: styles.chevron, d: "M6.5 8.5l3.5 3.5 3.5-3.5" })),
        label));
}
//# sourceMappingURL=ScrollLink.js.map